import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import Text from '../../Text';
import config from '../../../config';
import { withTheme } from '../../../core/ThemeProvider';
export var StyledFilterContainer = styled.div.withConfig({
  displayName: "styles__StyledFilterContainer",
  componentId: "sc-2f0vd4-0"
})(["display:flex;align-items:center;"]);
export var StyledFilterIconContainer = styled.div.withConfig({
  displayName: "styles__StyledFilterIconContainer",
  componentId: "sc-2f0vd4-1"
})(["display:flex;cursor:pointer;user-select:none;"]);
export var StyledSearchResultsHeading = withTheme(styled(Text).withConfig({
  displayName: "styles__StyledSearchResultsHeading",
  componentId: "sc-2f0vd4-2"
})(["flex:1;padding-right:", "px;"], function (p) {
  return p.coreTheme.space_4;
}));
export var StyledArrowIconContainer = withTheme(styled.div.withConfig({
  displayName: "styles__StyledArrowIconContainer",
  componentId: "sc-2f0vd4-3"
})(["margin-top:5px;margin-left:10px;stroke:", ";", ";"], function (p) {
  return p.coreTheme.cl_sec_d1;
}, config.media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    svg {\n      width: 22px;\n      height: 22px;\n      stroke: none;\n    }\n  "])))));
export var StyledViewMoreLessLinkContainer = withTheme(styled.div.withConfig({
  displayName: "styles__StyledViewMoreLessLinkContainer",
  componentId: "sc-2f0vd4-4"
})(["display:flex;align-items:center;cursor:pointer;user-select:none;padding-top:", "px;"], function (p) {
  return p.coreTheme.space_4;
})); // This style is used to start the slide animation of view more selectors from
// behind the initial result selectors.
// z-index only works on positioned elements. https://stackoverflow.com/a/32816773

export var StyledInitialResultSelectorContainer = styled.div.withConfig({
  displayName: "styles__StyledInitialResultSelectorContainer",
  componentId: "sc-2f0vd4-5"
})(["position:relative;z-index:1;"]);